import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { StyleSheet, Text } from "react-native"

export const BreeSerifText = (props) => {
    return (
        <Text
            style={[
                styles.text,
                {
                    textAlign: props.textAlign,
                    fontWeight: props.fontWeight,
                    fontSize: props.fontSize,
                    fontStyle: props.fontStyle,
                    color: props.color || baseColors.black,
                    ...props.style
                }
            ]}
        >
            {props.children}
        </Text>
    )
}

const styles = StyleSheet.create({
    text: {
        color: baseColors.black,
        fontFamily: "BreeSerif"
    }
})
